module.exports = __webpack_public_path__ + "assets/img/btn-view-info-9028ef16.png";